'use strict';

import FeedMove from './feedmove';

class Move2 extends FeedMove {
    constructor(x: number | null = null, y: number | null = null) {
        super(x, y, null, null);
    }
}

export default Move2;
